export default __webpack_public_path__ + "static/page_background_blue-50f6a9491555d5aaa2e4bd8104f486fb.jpg";